import { 
    LOGIN_DONE,
    LOGIN_ERROR,
    LOGIN_REQUEST,
    LOGOUT_REQUEST,
    LOGOUT_CONFIRMED,
    LOGOUT_CANCEL
} from "../../constants/action-types";

export function loginRequest(data){
    return { type: LOGIN_REQUEST, payload: data } }

export function loginSuccess(){
    return { type: LOGIN_DONE } }

export function loginError(){
    return { type: LOGIN_ERROR } }

export function logoutRequest(){
    return { type: LOGOUT_REQUEST } }

export function logoutConfirmed(){
    return { type: LOGOUT_CONFIRMED } }

export function logoutCancel(){
    return { type: LOGOUT_CANCEL } }



// WEBPACK FOOTER //
// ./src/store/actions/login.js